export default __webpack_public_path__ + "static/media/cow-one.77dfce44.jpeg";